import React, { Component } from 'react';
import {
    Col,
    Form,
    Radio,
    Row,
    Checkbox,
    Input,
    Divider,
} from 'antd';
import FormStepButton from '../FormStepButton';
import FormStepTitle from "../FormStepTitle";
import StatusMessage from '../../StatusMessage';
import {
    required,
    validateCity,
    validatePostcode,
} from '../../../constants/formValidation';


const { TextArea } = Input;

const HOUSE_TYPE = [
    'Detached',
    'Semi-Detached',
    'Terrace (End or Mid)',
    'Bungalow, Apartment',
    'Flat',
    'Maisonette',
];

class FormStepPropertyDetails extends Component {
    state = {
        errorMessage: null,
    };

    handleSubmit = e => {
        const { form, submitStep } = this.props;

        e.preventDefault();

        form.validateFields((err, values) => {
            if (err) return;

            const validateCityErrorMessage = validateCity(values);

            if (validateCityErrorMessage) {
                return this.setState({ errorMessage: validateCityErrorMessage });
            }

            submitStep(values);
        });
    }

    clearErrorMessage = () => {
        this.setState({ errorMessage: null });
    }

    render() {
        const { errorMessage } = this.state;
        const {
            form,
            formItemLayout,
        } = this.props;
        const { getFieldDecorator } = form;

        return (
            <Row gutter={40}>
                <Col span={24}>
                    <Form onSubmit={this.handleSubmit} {...formItemLayout}>
                        <FormStepTitle label="Add property address for your booking" />
                        <Form.Item label="Address Line 1">
                            {
                                getFieldDecorator('addressLine1', required())(
                                    <Input onChange={this.clearErrorMessage} />
                                )
                            }
                        </Form.Item>
                        <Form.Item label="Address Line 2">
                            {
                                getFieldDecorator('addressLine2')(
                                    <Input onChange={this.clearErrorMessage} />
                                )
                            }
                        </Form.Item>
                        <Form.Item label="Town / City">
                            {
                                getFieldDecorator('city', required())(
                                    <Input onChange={this.clearErrorMessage} />
                                )
                            }
                        </Form.Item>
                        <Form.Item label="Postcode">
                            {
                                getFieldDecorator('postcode', validatePostcode())(
                                    <Input onChange={this.clearErrorMessage} />
                                )
                            }
                        </Form.Item>
                        <Divider />
                        <FormStepTitle label="Add property details for your booking" />
                        <Form.Item label="What type of property do you have?">
                            {
                                getFieldDecorator('propertyType', { initialValue: HOUSE_TYPE[0] })(
                                    <Radio.Group buttonStyle="solid">
                                        {
                                            HOUSE_TYPE.map(type =>
                                                <Radio.Button value={type} key={type}>
                                                    { type }
                                                </Radio.Button>
                                            )
                                        }
                                    </Radio.Group>
                                )
                            }
                        </Form.Item>
                        <Form.Item>
                            {
                                getFieldDecorator('isParkingAvailable')(
                                    <Checkbox>Is parking available at your property?</Checkbox>
                                )
                            }
                        </Form.Item>
                        <Form.Item>
                            {
                                getFieldDecorator('hasAccessToBackOfProperty')(
                                    <Checkbox>Is there access to the back of the property?</Checkbox>
                                )
                            }
                        </Form.Item>
                        <Form.Item label="Additional comments">
                            {
                                getFieldDecorator('additionalComments')(
                                    <TextArea />
                                )
                            }
                        </Form.Item>
                        {
                            errorMessage &&
                            <StatusMessage message={errorMessage} variant="error" />
                        }
                        <FormStepButton />
                    </Form>
                </Col>
            </Row>
        );
    }
}

export default Form.create({ name: 'property' })(FormStepPropertyDetails);
